import React from "react";
import { Reveal, Overline } from "../components/site/Reveal";
import { SECTORS, IMAGES } from "../data/content";

export const About = () => (
  <section id="about" className="relative overflow-hidden bg-bg-light py-24 sm:py-32" data-testid="about-section">
    <div className="mx-auto grid max-w-[1400px] items-center gap-16 px-5 sm:px-8 lg:grid-cols-2">
      <div>
        <Reveal><Overline>About OnwardTranscends</Overline></Reveal>
        <Reveal delay={0.05}>
          <h2 className="mt-6 max-w-xl font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
            Strategic Thinking. Practical Transformation. <span className="text-gradient-emerald">Lasting Results.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-xl text-base leading-relaxed text-charcoal/70 sm:text-lg">
            OnwardTranscends is a multidisciplinary business and management consultancy helping organisations optimise
            performance, build resilient operations and develop people.
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-charcoal/70">
            We combine industry experience, data analytics, operational excellence, Lean Six Sigma, supply chain expertise,
            digital transformation, artificial intelligence and organisational psychology to create practical solutions
            tailored to each client — across the United Kingdom and internationally.
          </p>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-8 flex items-start gap-3 rounded-2xl border border-gold/30 bg-white p-5 card-shadow">
            <span className="mt-0.5 text-gold">✦</span>
            <p className="text-base font-medium leading-relaxed text-charcoal/85">
              We are not only a consultancy firm — we also operate as a <span className="font-semibold text-emerald-base">full supply chain execution business</span>, delivering across international trade, logistics and end-to-end supply chain transactions.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <div className="mt-10 flex flex-wrap gap-2.5">
            {SECTORS.map((s) => (
              <span key={s} className="rounded-full border border-emerald-base/15 bg-white px-4 py-2 text-sm font-medium text-emerald-base transition-colors duration-300 hover:border-gold hover:text-gold">
                {s}
              </span>
            ))}
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="relative">
        <div className="relative overflow-hidden rounded-[2rem] card-shadow">
          <img src={IMAGES.aboutOps} alt="Digital operations control room" className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-105" />
          <div className="absolute inset-0 bg-gradient-to-t from-emerald-darkest/50 to-transparent" />
        </div>
        <div className="absolute -bottom-6 -left-6 hidden rounded-2xl bg-emerald-base p-6 text-off-white shadow-xl sm:block">
          <p className="font-serif text-4xl text-gold-light">UK & Global</p>
          <p className="mt-1 text-sm text-off-white/70">Delivering measurable impact</p>
        </div>
      </Reveal>
    </div>
  </section>
);
